const ITEMS = [
  "MISSION",
  "BRIDGELAND",
  "KENSINGTON",
  "MARDA LOOP",
  "INGLEWOOD",
  "GO FAR. COME HOME.",
];

// Slim ticker below the hero. Tracked caps, slow auto-scroll, pauses on hover.
// Reduced-motion users get a static, non-animated row (handled in index.css).
export const Marquee = () => {
  const line = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <section
      className="relative overflow-hidden border-y"
      style={{ backgroundColor: "#24382E", borderColor: "rgba(200,154,78,0.28)" }}
      data-nav-theme="dark"
      data-testid="home-marquee"
      aria-label="Neighbourhoods we manage"
    >
      <div className="py-4">
        <div className="marquee-track animate-marquee">
          {line.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="label-caps text-[13px]" style={{ color: "#EDE9E0", letterSpacing: "0.24em" }}>
                {t}
              </span>
              <span
                aria-hidden="true"
                className="mx-6 inline-block"
                style={{ width: 5, height: 5, borderRadius: 999, backgroundColor: "#C89A4E" }}
              />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
